// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #fff;
  text-transform: capitalize;
}

.header a {
  text-decoration: none;
}

.profile-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  font-family: "Roboto";
}

.profile-detail span:last-child {
  font-size: 13px;
  font-weight: 500;
}

.sub-logo-img {
  height: 2.33rem;
  margin-top: 5px;
}

.userwelcome {
  cursor: pointer;
  text-shadow: 0px 0px 1px rgb(170, 170, 170);
}

.welcome-home-dropdown {
  width: 17rem;
  border: 1px solid #333333;
  position: absolute;
  right: 1rem;
  top: 3.5rem;
  background: rgba(250, 252, 252, 0.95);
  z-index: 90;
  border-radius: 15px;
  text-shadow: 0px 0px 1px rgb(170, 170, 170);
}

.welcome-home-dropdown a {
  display: block;
  text-align: center;
  font-size: 1rem;
  padding: 0.5rem;
  text-decoration: none;
  transition: color 0.2s, background-color 0.2s;
  color: #333333;
  text-shadow: 0px 0px 1px rgb(170, 170, 170);
}

.welcome-home-dropdown a:hover {
  background-color: rgb(238, 70, 81);
  color: white;
  border-radius: 13px;
  cursor: pointer;
}

::ng-deep .mat-mdc-button,
::ng-deep .mat-mdc-menu-item {
  outline: none !important;
}
::ng-deep .mdc-button__label {
  align-items: flex-start !important;
}
::ng-deep .mat-mdc-button {
  height: -moz-fit-content !important;
  height: fit-content !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/header/header.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACC,sBCDkB;EDElB,0BAAA;AADD;;AAIA;EACC,qBAAA;AADD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;AAAD;;AAEA;EACC,eAAA;EACA,gBAAA;AACD;;AACA;EACC,eAAA;EACA,eAAA;AAED;;AACA;EACC,eAAA;EACA,2CAAA;AAED;;AACA;EACC,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;AAED;;AACA;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,6CAAA;EACA,cC/BoB;EDgCpB,2CAAA;AAED;;AACA;EACC,kCClDe;EDmDf,YCrDgB;EDsDhB,mBAAA;EACA,eAAA;AAED;;AAEC;;EAEC,wBAAA;AACF;AACC;EACC,kCAAA;AACF;AACC;EACC,mCAAA;EAAA,8BAAA;AACF","sourcesContent":["@import '../../../scss/variables';\n\n.header {\n\tbackground-color: $background-color;\n\ttext-transform: capitalize;\n}\n\n.header a {\n\ttext-decoration: none;\n}\n.profile-detail{\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\ttext-align: right;\n\tcolor: rgba(0, 0, 0, 0.85);\n\tfont-family: \"Roboto\";\n}\n.profile-detail span:last-child{\n\tfont-size: 13px;\n\tfont-weight: 500;\n}\n.sub-logo-img {\n\theight: 2.33rem;\n\tmargin-top: 5px;\n}\n\n.userwelcome {\n\tcursor: pointer;\n\ttext-shadow: 0px 0px 1px rgb(170, 170, 170);\n}\n\n.welcome-home-dropdown {\n\twidth: 17rem;\n\tborder: 1px solid $primary-font-color;\n\tposition: absolute;\n\tright: 1rem;\n\ttop: 3.5rem;\n\tbackground: rgba(250, 252, 252, 0.95);\n\tz-index: 90;\n\tborder-radius: 15px;\n\ttext-shadow: 0px 0px 1px rgb(170, 170, 170);\n}\n\n.welcome-home-dropdown a {\n\tdisplay: block;\n\ttext-align: center;\n\tfont-size: 1rem;\n\tpadding: 0.5rem;\n\ttext-decoration: none;\n\ttransition: color 0.2s, background-color 0.2s;\n\tcolor: $primary-font-color;\n\ttext-shadow: 0px 0px 1px rgb(170, 170, 170);\n}\n\n.welcome-home-dropdown a:hover {\n\tbackground-color: $primary-color;\n\tcolor: $selected-metal;\n\tborder-radius: 13px;\n\tcursor: pointer;\n}\n\n::ng-deep {\n\t.mat-mdc-button,\n\t.mat-mdc-menu-item {\n\t\toutline: none !important;\n\t}\n\t.mdc-button__label{\n\t\talign-items: flex-start !important;\n\t}\n\t.mat-mdc-button{\n\t\theight: fit-content !important;\n\t}\n}\n","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
